import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AuthCardTitle } from './AuthCardTitle';
import { AuthLayout } from './AuthLayout';
import { AuthSubTitle } from './AuthSubTitle';

interface Props {
  errorReason: string;
  loginRoute: string;
}

export const AuthError = ({ errorReason, loginRoute }: Props) => {
  const { t } = useTranslation('AuthError');

  return (
    <AuthLayout title={t('wentWrong')}>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow rounded-lg sm:px-10">
          <AuthCardTitle>{t('wentWrong')}</AuthCardTitle>
          <AuthSubTitle>{errorReason}</AuthSubTitle>
          <div className="mt-4" />
          <Link
            to={loginRoute}
            className={`inline-flex w-full justify-center w-sm py-2 px-6 shadow-sm text-sm font-md rounded-md text-primary hover:text-primary-500 bg-primary-light hover:bg-secondary-light hover:text-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:bg-gray-300`}
          >
            {t('backLink')}
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
};
